import { useMemo } from 'react';

import { useGraphqlClient } from '@/shared/hooks/useGraphqlClient';

import { createChannelWallpaperManager } from '../lib/channelWallpaperManager';

export function useChannelsWallpapersManager() {
    const client = useGraphqlClient();

    return useMemo(() => createChannelWallpaperManager({ graphqlClient: client }), [client]);
}
